import React from 'react';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import { MainSection } from './MainSection/MainSection';
import '../CSSRules/normalize.css';
import { AboutUsSection } from './AboutUsSection/AboutUsSection';
import { ContactSection } from './ContactSection/ContactSection';
import { Footer } from '../view/Footer/Footer';
import { EcologySection } from './EcologySection/EcologySection';
import { TeamSection } from './TeamSection/TeamSection';

export function App(): JSX.Element {
  return (
    <>
      <Router>
        <Switch>
          <Route exact path="/">
            <MainSection />
          </Route>
          <Route exact path="/aboutUs">
            <AboutUsSection />
          </Route>
          <Route exact path="/contactUs">
            <ContactSection />
          </Route>
          <Route exact path="/ecology">
            <EcologySection />
          </Route>
          <Route exact path="/team">
            <TeamSection />
          </Route>
        </Switch>
        <Footer />
      </Router>
    </>
  );
}
